export default "__VITE_ASSET__Bcqi3Q9n__"